import { takeLatest, put, call } from 'redux-saga/effects';

import { findAllTransferenciaEstoque } from '../service';
import {
  LIST_TRANSFERENCIA_ESTOQUE,
  LIST_TRANSFERENCIA_ESTOQUE_PENDING,
  LIST_TRANSFERENCIA_ESTOQUE_SUCCESS,
  LIST_TRANSFERENCIA_ESTOQUE_FAILURE
} from '../actionTypes';

function* sagaListAllTransferenciaEstoque(action) {
  yield put({ type: LIST_TRANSFERENCIA_ESTOQUE_PENDING })

  try {
    const list = yield call(findAllTransferenciaEstoque)
    
    yield put({ type: LIST_TRANSFERENCIA_ESTOQUE_SUCCESS, list: list })
  } catch (error) {

    yield put({ type: LIST_TRANSFERENCIA_ESTOQUE_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListAllTransferenciaEstoque() {
  yield takeLatest(LIST_TRANSFERENCIA_ESTOQUE, sagaListAllTransferenciaEstoque)
}